import { translate } from '@/domains/core/localization/translate';
export const {
  top,
  valueForMoney,
  electedByCustomers
} = translate({
  "top": "Top",
  "valueForMoney": "Value for money",
  "electedByCustomers": "voted by customers"
});